import { useMemo } from 'react';
import { createStringDataField, createBooleanDataField, createDateField, createListField } from '../../util/format';

export function useSupplementaryPromptsFields() {
    return useMemo(() => [
        createListField('contractNames', 'Contracts', { sortable: false, hideFromFilter: true }),
        createStringDataField('updatedBy', 'Updated By', { sortable: true }),
        createDateField('updatedAt', 'Updated At', { sortable: true }),
    ], []);
}

export { default as SupplementaryPromptsPage } from './SupplementaryPromptsPage';
